/* assets/abee-modals.js */
(() => {
  // Empêche double init (thème editor / re-renders)
  if (window.__ABEE_MODALS_INIT__) return;
  window.__ABEE_MODALS_INIT__ = true;

  const OPEN_CLASS = "is-open";
  const LOCK_CLASS = "abee-modal-open";

  const getSectionIdFromButton = (btn) => {
    // Cherche le wrapper product-info (ou le bloc MainProduct-xxxx)
    const root =
      btn.closest('product-info[id^="MainProduct-"]') ||
      btn.closest('[id^="MainProduct-"]');

    if (!root) return null;

    const id = root.getAttribute("id"); // "MainProduct-{{ section.id }}"
    return id ? id.replace("MainProduct-", "") : null;
  };

  const lockScroll = () => {
    document.documentElement.classList.add(LOCK_CLASS);
    document.body.classList.add(LOCK_CLASS);
  };

  const unlockScrollIfNoOpenModal = () => {
    const anyOpen = document.querySelector(`.abee-modal.${OPEN_CLASS}`);
    if (!anyOpen) {
      document.documentElement.classList.remove(LOCK_CLASS);
      document.body.classList.remove(LOCK_CLASS);
    }
  };

  const openModal = (modal) => {
    if (!modal) return;

    // Save focus to restore later
    modal.__previousActiveElement = document.activeElement;

    modal.classList.add(OPEN_CLASS);
    modal.setAttribute("aria-hidden", "false");
    lockScroll();

    // Focus close button (accessibilité)
    const closeBtn = modal.querySelector(".abee-modal__close");
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  };

  const closeModal = (modal) => {
    if (!modal) return;

    modal.classList.remove(OPEN_CLASS);
    modal.setAttribute("aria-hidden", "true");

    // Restore focus
    const prev = modal.__previousActiveElement;
    if (prev && typeof prev.focus === "function") {
      prev.focus({ preventScroll: true });
    }

    unlockScrollIfNoOpenModal();
  };

  const closeAll = () => {
    document.querySelectorAll(`.abee-modal.${OPEN_CLASS}`).forEach(closeModal);
  };

  // Event delegation: ouvre/ferme même si Shopify re-render la section
  document.addEventListener("click", (e) => {
    const openBtn = e.target.closest("button[data-abee-modal]");
    if (openBtn) {
      e.preventDefault();

      const key = openBtn.getAttribute("data-abee-modal"); // details / application / features
      const sectionId = getSectionIdFromButton(openBtn);

      if (!key || !sectionId) return;

      const modalId = `abee-modal-${key}-${sectionId}`;
      const modal = document.getElementById(modalId);

      openModal(modal);
      return;
    }

    const closeBtn = e.target.closest(".abee-modal__close");
    if (closeBtn) {
      const modal = closeBtn.closest(".abee-modal");
      closeModal(modal);
      return;
    }

    // Clic sur le fond (outside)
    const modal = e.target.closest(".abee-modal");
    if (modal && modal.classList.contains(OPEN_CLASS) && e.target === modal) {
      closeModal(modal);
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeAll();
  });

  // Option: si un modal est ouvert et que Shopify reload la section, on nettoie
  document.addEventListener("shopify:section:unload", () => {
    closeAll();
  });
})();
